import React, { useState, useEffect } from 'react';
import MUIEditor, {toolbarControlTypes} from 'react-mui-draft-wysiwyg';
import { EditorState, ContentState, convertToRaw, convertFromHTML } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
function CampaignWysiwyg(props) {
  const { content, onContentChange } = props;
  let defaultContent = "";
  const initialEditorState = EditorState.createWithContent(
    ContentState.createFromText(defaultContent)
  );

  const [editorState, setEditorState] = useState(initialEditorState);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (content && isLoading === false) {
      const blocksFromHTML = convertFromHTML(content);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      const newEditorState = EditorState.createWithContent(contentState);
      setEditorState(newEditorState);
      setIsLoading(true);
    }
  }, [content]);

  const handleEditorChange = (newEditorState) => {
    setEditorState(newEditorState);
    const contentState = convertToRaw(newEditorState.getCurrentContent());
    const contentHtml = draftToHtml(contentState);
    onContentChange(contentHtml);
  };

  return (
    <MUIEditor
      editorState={editorState}
      onChange={handleEditorChange}
      config={{
        toolbar: {
          controls: [
            toolbarControlTypes.undo,
            toolbarControlTypes.redo,
            toolbarControlTypes.divider,
            toolbarControlTypes.bold,
            toolbarControlTypes.italic,
            toolbarControlTypes.underline,
            toolbarControlTypes.strikethrough,
            toolbarControlTypes.fontBackgroundColor,
            toolbarControlTypes.divider,
            // toolbarControlTypes.linkAdd,
            // toolbarControlTypes.linkRemove,
            // toolbarControlTypes.image,
            toolbarControlTypes.divider,
            toolbarControlTypes.blockType,
            toolbarControlTypes.fontSize,
            toolbarControlTypes.fontFamily,
            toolbarControlTypes.textAlign,
            toolbarControlTypes.divider,
            // toolbarControlTypes.unorderedList,
            toolbarControlTypes.orderedList
          ]
        }
      }}
    />
  );
}

export default CampaignWysiwyg;
